import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {unwatchTicketMutation, UnwatchTicketInput} from './__generated__/unwatchTicketMutation.graphql';

const mutation = graphql`
	mutation unwatchTicketMutation($input: UnwatchTicketInput!) {
		unwatchTicket(input: $input) {
			clientMutationId
			ticket {
				id
				isWatching
				watcherCount
				watchers {
					id
					person {
						id
						...ticketingPerson_person
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UnwatchTicketInput,
	onCompleted?: (r: unwatchTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<unwatchTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'unwatchTicketMutation'};
